import { combineReducers } from 'redux'

import listWithdrawal from './listWithdrawal'
import acceptWithdrawal from './acceptWithdrawal'
import rejectWithdrawal from './rejectWithdrawal'

export default combineReducers({
  listWithdrawal: listWithdrawal,
  acceptWithdrawal: acceptWithdrawal,
  rejectWithdrawal: rejectWithdrawal
})
